import React, { Component } from 'react'
import './Hoofdding.css';

export default class Hoofdding extends Component {
    render() {
        return (
            <header>
                <div className="Titel">Anime Sounds</div>
            </header>
        )
    }
}
